
import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';
import { Button } from "react-bootstrap";
import app_params from "modules/search/config/params";
import { searchService } from "services/BackendApi/searchService";
import SearchBarWidget from "modules/search/components/SearchBar/SearchBar";
import { Trash3 } from "react-bootstrap-icons";
import ShareModal from "modules/search/components/ShareModal/ShareModal";
import SearchFilters from "modules/search/components/SearchFilters/SearchFilters";
import FiltersModal from "modules/search/components/FiltersModal/FiltersModal";
import { searchResultDummy } from "modules/search/dummy/searchresult";
import LoadingBox from "modules/search/components/LoadingBox/LoadingBox";
import MessageBox from "modules/search/components/MessageBox/MessageBox";
import styles from './CarritoView.module.scss'
import Modal from 'react-bootstrap/Modal';
import { isDisabled } from "@testing-library/user-event/dist/utils";

export default function CarritoView() {
    const [lista, setLista] = useState([]);
    const [total, setTotal] = useState(0);
    const [open, setOpen] = useState(false);
    const [disableUpdate, setDisableUpdate] = useState(true);
    const [tipo, setTipo] = useState();
    const [texto, setTexto] = useState([]);

    const modalClose = () => setOpen(false);

    async function modalOpen(name) {
        const res = await Axios.ValidarLote({ urlParams: '1' });
        // console.log(res)
        setTexto(res?.data)
        setOpen(true)
        setTipo(name)
    };

    useEffect(() => {
        getReservas()
        localStorage.setItem('reservas', total);
        window.dispatchEvent(new Event('storage'));
        if (total > 0) {
            setDisableUpdate(false)
        }
    }, [total]);


    async function getReservas() {
        let carrito = await Axios.GetCarrito({ urlParams: "1" });
        console.log(carrito)
        setLista(carrito?.data)
        setTotal(carrito?.data?.length)
        let res = await Axios.ValidarLote({ urlParams: '1' });
        console.log(res)
        // setTexto(res?.data)
    }

    const BorrarItem = async (id) => {
        let carrito = await Axios.DiscardItem({ urlParams: { id } });
        setLista(carrito?.data)
        setTotal(carrito?.data?.length)

    }

    async function Borrar() {
        await Axios.DiscardItem({ urlParams: { id: null } });
        setLista([])
        setTotal(0)
        setOpen(false);
    }

    async function Reservar() {
        await Axios.ReservarLote({ urlParams: '1' });
        setLista([])
        setTotal(0)
        setDisableUpdate(false)
        setOpen(false);
    }
    // async function Validar() {
    //     await Axios.ReservarLote({ urlParams: '1' });
    //     setLista([])
    //     setTotal(0)
    //     setOpen(false);
    // }





    return (
        <><h2>Listado de reservas</h2>
            <br />
            <div className="row">

                <div className="col-7">
                    {
                        lista?.map((element, idx) => {
                            return <>
                                <div className="card mb-3" >
                                    <div className="card-header">
                                        <div className="d-flex flex-row justify-content-between">
                                            <div>
                                                <b>Item:</b> {element?.document}
                                            </div>
                                            <h5>
                                                <span className={styles.trash} onClick={() => BorrarItem(element?.id)}>
                                                    <Trash3 />
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-lg-10 mb-2">
                                                <div>
                                                    <b>Ubicación: </b>
                                                    {element?.location}
                                                    {/* {texto} */}
                                                </div>
                                                <div>
                                                    <b>Circulación: </b>
                                                    Normal de unidad documental (3-15 dias)
                                                </div>
                                                <div>
                                                    <b>Tipo de documento: </b>
                                                    {element?.tipo}
                                                </div>
                                                <span className="me-2">
                                                    <i className="fas fa-globe-americas"></i>
                                                </span>
                                            </div>
                                            <div className="col-2 d-none d-lg-flex flex-column justify-content-start">
                                                <a href={`${app_params.basepath}/view/false/${element?.document}`} className="text-decoration-none" target="_blank">
                                                    <Button className={styles.view}>
                                                        Ver Documento
                                                    </Button>
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        })
                    }
                </div>
                <div className="col-5">
                    <div className="row">
                        <div className="col">
                            <h3>Total de documentos: {total}</h3>
                        </div>
                        <div className="col">
                            <Button className={styles.buttons} onClick={() => modalOpen("reservar")} disabled={disableUpdate}>Solicitar prestamos</Button>
                            <br /><br />
                            <Button className={styles.buttons} variant="danger" onClick={() => modalOpen("vaciar")} disabled={disableUpdate}>Vaciar Carrito</Button>

                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} onHide={modalClose} dialogClassName={styles.alerta}>
                <Modal.Header className={styles.header}>
                    <Modal.Title style={{ color: 'white' }}>Alerta</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.columna}>
                    <div>
                        {tipo === "reservar" ? (
                            <>
                                {total - texto.length > 0 && <h5>Está seguro de reservar {total - texto.length} documento(s)? </h5>}
                                <br />
                                {texto.length > 0 && <h5>Estos elementos ya no están disponibles porque otro usuario los reservó</h5>}
                                {texto.length > 0 && texto?.map((element, idx) => <ol><li key={idx}>{element}</li></ol>)}
                            </>
                        ) : (
                            <h5>¿Está seguro de vaciar el carrito?</h5>
                        )}
                    </div>
                    {tipo === "reservar" ? (
                        <>
                        <Button className={styles.alertButtons} onClick={()=>Reservar()} disabled={total - texto.length == 0 ? true : false}>Reservar</Button>
                        <Button className={styles.alertButtons} variant="danger" onClick={()=>setOpen(false)} disabled={total - texto.length == 0 ? true : false}>Cancelar</Button>
                        </>
                    ) : (
                        <Button className={styles.alertButtons} variant="danger" onClick={Borrar}>Vaciar</Button>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );

}